export default __webpack_public_path__ + "static/media/gournay18.907f5b1f.jpg";